import Icon from '../components/Icon.vue'

Icon.register({
  receipt: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M358.4 3.2c10.6-7.9 25.6-0.4 25.6 12.8v480c0 13.2-15.1 20.7-25.6 12.8l-38.4-44.8-54.4 44.8c-2.4 1.8-6.7 3.2-9.6 3.2s-7.2-1.4-9.6-3.2l-54.4-44.8-54.4 44.8c-2.4 1.8-6.7 3.2-9.6 3.2s-7.2-1.4-9.6-3.2l-54.4-44.8-38.4 44.8c-10.6 7.9-25.6 0.4-25.6-12.8v-480c0-13.2 15-20.7 25.6-12.8l38.4 44.8 54.4-44.8c2.4-1.8 6.7-3.2 9.6-3.2s7.2 1.4 9.6 3.2l54.4 44.8 54.4-44.8c2.4-1.8 6.7-3.2 9.6-3.2s7.2 1.4 9.6 3.2l54.4 44.8zM320 360v-16c0-4.4-3.6-8-8-8h-240c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8zM320 264v-16c0-4.4-3.6-8-8-8h-240c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8zM320 168v-16c0-4.4-3.6-8-8-8h-240c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/receipt.js
// module id = 1679
// module chunks = 0